import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

export const embla = {
  useEmblaCarousel,
  plugins: {
    Autoplay,
  },
};
